// Shared gallery event data, consumed by the gallery page and the home page highlight.
// Each event's photos live in its own folder here and are picked up automatically,
// so adding an image to a folder is enough to show it on the site.

const IMAGE_PATTERN = /\.(jpe?g|png|webp)$/i;

// Sorts "name.jpg, name1.jpg, name (2).jpg" the way the files read rather than the way
// the alphabet does: only a number at the end of the name counts, so the unnumbered
// cover photo stays first and a leading "3rd" in a name is ignored.
const trailingNumber = (path) => {
  const match = path.replace(/\.[^.]+$/, "").match(/(\d+)\)?$/);
  return match ? Number(match[1]) : 0;
};

const loadFolder = (context) =>
  context
    .keys()
    .filter((key) => IMAGE_PATTERN.test(key))
    .sort((a, b) => trailingNumber(a) - trailingNumber(b) || a.localeCompare(b))
    .map((key) => context(key));

const radissonBluImages = loadFolder(require.context("./Radisson Blu Event", false, /\.(jpe?g|png|webp)$/i));
const firstMeetImages = loadFolder(require.context("./first meet n greet", false, /\.(jpe?g|png|webp)$/i));
const secondMeetImages = loadFolder(require.context("./second meet n greet", false, /\.(jpe?g|png|webp)$/i));
const thirdMeetImages = loadFolder(require.context("./3rd meet n greet", false, /\.(jpe?g|png|webp)$/i));
const padelMeetupImages = loadFolder(require.context("./meetup over padel", false, /\.(jpe?g|png|webp)$/i));

export const pastEvents = [
  {
    id: "radisson-blu-open-house",
    title: "Radisson Blu Open House",
    date: "July 01 | 2024",
    sortDate: "2024-07-01",
    location: "PC Hotel, Karachi",
    description:
      "A significant leap forward in purpose-built real estate and luxury hospitality. This grand event highlighted J7's commitment to transforming Islamabad's skyline and bolstering the hospitality sector across Pakistan.Facilitated by the Proptech Club, the launch not only showcased the sophisticated elegance of Radisson BLU Hotel & Residences, Islamabad but also emphasized our dedication to revitalizing the hospitality industry. ",
    images: radissonBluImages,
  },
  // {
  //   id: "site-nooriabad-phase-iii",
  //   title: "SITE Nooriabad Phase III",
  //   date: "May 24 | 2024",
  //   sortDate: "2026-05-24",
  //   location: "Nooriabad Phase III",
  //   description:
  //     "A field-led ecosystem session focused on industrial growth, real estate development, and infrastructure opportunities.",
  // },
  {
    id: "first-official-meet-greet",
    title: "1st Official Meet & Greet",
    date: "October 02 | 2024",
    sortDate: "2024-10-02",
    location: "Karachi Club Annexe",
    description:
      "The PropTech Club proudly hosted the 1st Official Meet & Greet of The PropTech Club on October 2nd, 2024, at Karachi Club Annexe! A big thank you to all the industry leaders, innovators, and stakeholders who attended and made this event a resounding success. This gathering marks a significant milestone as we aim to foster greater collaboration and technological innovation in the real estate ecosystem of Pakistan. The event provided an incredible opportunity for professionals to connect, share ideas, and drive the industry forward through PropTech.",
    images: firstMeetImages,
  },
  {
    id: "second-official-meet-greet",
    title: "2nd Official Meet & Greet",
    date: "April 24 | 2025",
    sortDate: "2025-04-24",
    location: "The Lounge, DHA Karachi",
    description:
      "The 2nd Official Meet & Greet of The PropTech Club, powered by LandTrack.pk, brought together visionary minds from real estate, tech, development, and finance, all committed to redefining how Pakistan builds, buys, and scales through innovation. Held at The Lounge, DHA Karachi, this invite-only gathering was a powerful reflection of what’s possible when consistent community building happens beyond the big stage. At PropTech Club, this is just the beginning, stay tuned for more conversations, collaborations, and action across the country.",
    images: secondMeetImages,
  },
  {
    id: "third-official-meet-greet",
    title: "3rd Official Meet & Greet",
    date: "April 11 | 2026",
    sortDate: "2026-04-11",
    location: "Tapestry Cafe, DHA Karachi",
    description:
      "Real estate doesn’t lack opportunity , it lacks alignment. Developers, capital, and operators often move in parallel, but rarely in sync. And that’s where inefficiencies begin. The 3rd Official Eid Meet & Greet by PropTech Club at Tapestry Café was designed to address exactly that. Bringing the right stakeholders into one environment, not for visibility, but for clarity. The event was a powerful reminder that when the right people come together, with the right intent, real estate can move faster, smarter, and more efficiently.",
    images: thirdMeetImages,
  },
  {
    id: "meetup-over-padel",
    title: "Meetup Over Padel",
    date: "July 31 | 2026",
    sortDate: "2026-07-31",
    location: "The Padel Grid, DHA Phase 2",
    description:
      "Our Meetup Over Padel brought together professionals from across the real estate, proptech, business, and entrepreneurial ecosystem for an evening filled with meaningful conversations, new connections, friendly matches, and shared opportunities. A heartfelt thank you to everyone who joined us and made it such a memorable success. Your energy, participation, and enthusiasm is making The PropTech Club community stronger. Special thanks to Pakistan-UK & Ireland Business Council - FPCCI, Institute of Business Management & #breakingground, and Landtrack.global.",
    images: padelMeetupImages,
  },
];

export const sortEventsNewestFirst = (events) =>
  [...events].sort((a, b) => new Date(b.sortDate).getTime() - new Date(a.sortDate).getTime());

// Only events that actually have photos are worth featuring on the home page.
export const getLatestEvent = () =>
  sortEventsNewestFirst(pastEvents).find((event) => (event.images || []).length > 0);
